module.exports = __webpack_public_path__ + "cbf7dde8cc54da832a1ea1bcd9e1516f.png";